import qs from 'qs';
import type { CpdDto } from '../models/cpdDto';
import type { SearchCreditRecordsQuery } from '../models/searchCreditRecordsQuery';
import type { GetDocumentParamObj } from '../common/getDocumentParamObj';
import { requests, apiClient, responseBody } from '../../../app/api/httpClient';

export const Credits = {
    addCpdDetailsAsync: (data: CpdDto) => requests.post(`Credits`, data),
    updateCpdDetailsAsync: (data: CpdDto) => requests.put(`Credits`, data),
    cloneCpdDetailsAsync: (data: CpdDto) => requests.post(`Credits`, data),
    deleteCpdDetailsAsync: (id: string) => requests.delete(`Credits/${id}`),
    getCpdDetailsAsync: (id: string) => requests.get(`Credits/${id}`),
    getCpdStatusHistoryAsync: (id: string) => requests.get(`Credits/${id}/StatusHistory`),
    getCreditRecordsAsync: (data: SearchCreditRecordsQuery) =>
        apiClient.get(`Credits`, {
            params: {
                personId: data.personId,
                year: data.year,
                cpdCategoryID: data.cpdCategoryID,
                cpdRecordStatusID: data.cpdRecordStatusID
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        }).then(responseBody),
    getDocumentsByCreditRecordIdAsync: (creditRecordId: string) => requests.get(`Credits/${creditRecordId}/Document`),
    getDocumentsAsync: () => requests.get(`Credits/Documents`),
    getDocumentAsync: (getDocumentParamObj: GetDocumentParamObj) =>
        requests.getConfig<Blob>(`Credits/${getDocumentParamObj.creditRecordId}/Document/${getDocumentParamObj.fileName}`,
            { responseType: 'blob' }),
    addDocumentAsync: (data: FormData) => requests.post(`Credits/Document`, data, {
        headers: {
            "content-type": "multipart/form-data"
        }
    }),
    deleteDocumentAsync: (getDocumentParamObj: GetDocumentParamObj) => requests.delete(`Credits/${getDocumentParamObj.creditRecordId}/Document/${getDocumentParamObj.fileName}`)
};
